import React from "react"

import InnerAndOuterLengthConfigurationInput from "components/Configurations/InnerAndOuterLengthConfigurationInput"

import {
	DispatchProductDetailPageReducer,
	setSelectedOuterLength,
	setSelectedInnerLength,
	ProductDetailPageReducerState,
} from "@secureo/common/reducers/productDetailPageReducer"

const InnerAndOuterLengthConfiguration = ({
	isLoading,
	dispatch,
	reducerState,
	accessToken,
}: Props) => {
	const {
		selectedOuterLength,
		selectedInnerLength,
		attributes: { innerLengthsByOuterLengths },
	} = reducerState

	const onOuterLengthChange = (selectedOuterLength: number) => {
		setSelectedOuterLength(accessToken, dispatch, reducerState, selectedOuterLength)
	}

	const onInnerLengthChange = (selectedInnerLength: number) => {
		setSelectedInnerLength(accessToken, dispatch, reducerState, selectedInnerLength)
	}

	return (
		<InnerAndOuterLengthConfigurationInput
			innerLengthsByOuterLengths={innerLengthsByOuterLengths}
			selectedOuterLength={selectedOuterLength}
			selectedInnerLength={selectedInnerLength}
			onOuterLengthChange={onOuterLengthChange}
			onInnerLengthChange={onInnerLengthChange}
			disabled={isLoading || !accessToken}
			showMeasureCylinderDialog
		/>
	)
}

interface Props {
	isLoading: boolean
	dispatch: DispatchProductDetailPageReducer
	reducerState: ProductDetailPageReducerState
	accessToken: string
}

export default InnerAndOuterLengthConfiguration
